import { useState } from "react";
import { Box, Flex } from "@chakra-ui/react";
import { FaChevronDown } from "react-icons/fa6";

const SMOOTH = "cubic-bezier(0.4, 0, 0.2, 1)";

const Select = ({
  label,
  value,
  onChange,
  options,
  icon,
  accent = "#04aec1",
  autoComplete,
}) => {
  const [focus, setFocus] = useState(false);
  const filled = !!value;
  const isFloating = focus || filled;
  const iconLeft = icon ? "38px" : "14px";

  return (
    <Box position="relative">
      <Box
        position="relative"
        bg={focus ? "#ffffff" : "rgba(255,255,255,0.85)"}
        border="1px solid"
        borderColor={focus ? accent : "rgba(15,22,38,0.10)"}
        borderRadius="12px"
        transition={`border-color .2s ${SMOOTH}, background .2s ${SMOOTH}, box-shadow .2s ${SMOOTH}`}
        boxShadow={
          focus
            ? `0 0 0 4px ${accent}22, 0 8px 22px -10px ${accent}55`
            : "none"
        }
      >
        {icon && (
          <Flex
            position="absolute"
            left="14px"
            top="50%"
            transform="translateY(-50%)"
            color={focus ? accent : "rgba(15,22,38,0.55)"}
            fontSize="14px"
            transition={`color .2s ${SMOOTH}`}
            pointerEvents="none"
            align="center"
            justify="center"
          >
            {icon}
          </Flex>
        )}

        <Box
          as="label"
          position="absolute"
          left={iconLeft}
          top={isFloating ? "6px" : "50%"}
          transform={isFloating ? "translateY(0)" : "translateY(-50%)"}
          fontSize={isFloating ? "10px" : "13px"}
          fontWeight={isFloating ? 600 : 500}
          letterSpacing={isFloating ? "0.08em" : 0}
          textTransform={isFloating ? "uppercase" : "none"}
          color={focus ? accent : "rgba(15,22,38,0.55)"}
          transition={`all .2s ${SMOOTH}`}
          pointerEvents="none"
          bg="transparent"
        >
          {label}
        </Box>

        <Box
          as="select"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onFocus={() => setFocus(true)}
          onBlur={() => setFocus(false)}
          autoComplete={autoComplete}
          width="100%"
          height="56px"
          background="transparent"
          border="none"
          outline="none"
          fontSize="14px"
          fontWeight={500}
          color="#0a0e1a"
          padding={`24px 40px 8px ${icon ? "38px" : "14px"}`}
          appearance="none"
          cursor="pointer"
          boxSizing="border-box"
          sx={{
            WebkitAppearance: "none",
            MozAppearance: "none",
            "& option": { color: "#0a0e1a", background: "white" },
          }}
        >
          <option value="" disabled hidden></option>
          {options.map((o) => (
            <option key={o} value={o}>
              {o}
            </option>
          ))}
        </Box>

        <Box
          position="absolute"
          right="14px"
          top="50%"
          transform="translateY(-50%)"
          color="rgba(15,22,38,0.5)"
          fontSize="11px"
          pointerEvents="none"
          display="grid"
          placeItems="center"
        >
          <FaChevronDown />
        </Box>
      </Box>
    </Box>
  );
};

export default Select;
